module.exports = __webpack_public_path__ + "static/img/sk.b84444bf.svg";